import { SearchForMedicalPaOrdersFromPostgresParams } from "../../../../api/postgreSQL/postCalls/searchForMedicalPaOrdersFromPostgres";

/**
 * Generates an array of paginated search payloads for batch-fetching initial data.
 * Creates one payload per page from 0 through batchNumber (inclusive), each with
 * the same filter parameters but an incrementing page number. Also stamps the
 * active server-side sort onto each page payload so the restored data is fetched
 * in the same order the user last saw.
 *
 * @param filterPayload - Base search parameters to replicate for each page
 * @param batchNumber - The highest page index to include (0-based)
 * @param sortByField - Canonical backend field name to sort by (empty string for no sort)
 * @param sortAscending - Sort direction; true for ascending, false for descending
 * @returns Array of search parameter objects, one per page
 */
export const recursivelyGeneratePayloadForInitialFetch = (
  filterPayload: SearchForMedicalPaOrdersFromPostgresParams,
  batchNumber: number,
  sortByField: string,
  sortAscending: boolean,
): SearchForMedicalPaOrdersFromPostgresParams[] => {
  const arraysFromBatchNumber = Array.from(
    { length: batchNumber + 1 },
    (_, index) => index,
  );
  return arraysFromBatchNumber.map((index) => ({
    ...filterPayload,
    page: index,
    ...(sortByField
      ? {
          sort_by: sortByField,
          sort_dir: sortAscending ? "asc" : "desc",
        }
      : {}),
  }));
};
